import { render, staticRenderFns } from "./FormPage.vue?vue&type=template&id=3c2e74b1&scoped=true"
import script from "./FormPage.vue?vue&type=script&lang=ts"
export * from "./FormPage.vue?vue&type=script&lang=ts"
import style0 from "./FormPage.vue?vue&type=style&index=0&id=3c2e74b1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2e74b1",
  null
  
)

export default component.exports